export const ACCESS_TOKEN = 'access';
export const REFRESH_TOKEN = 'refresh';
export const SERVER_URL = 'https://internapi.thehackbio.com';
//export const SERVER_URL = 'http://127.0.0.1:8000/';
